import { Box, Text } from "@/ui";
import { useEffect } from "react";
import { t } from "@/utils";
import NavigationBar from "@/components/NavigationBar";
import { useControls, useDisableNavigationEvents } from "@/hooks";
import { dataSyncEmitter } from "@/modules/events/emitter";
import DiscardDialog from "./DetectionZones/DiscardDialog";

export default function DetectionZonesHelp({ previous, state, onClose }: CSTypes.CameraSettingsStepProps) {
  const { isOpen, open, close } = useControls();
  useDisableNavigationEvents(false);

  const handleModalPreventedClose = (reason: ModalCloseSource) => {
    if (reason === "esc") previous();
    else {
      if (state.detectionZonesState?.hasUnsavedChanges) open();
      else onClose();
    }
  };

  useEffect(() => {
    return dataSyncEmitter.on("modal-prevented-close", handleModalPreventedClose);
  });

  return (
    <Box>
      <NavigationBar
        title={t("detectionZone")}
        onBack={previous}
        props={{ mb: "8", justifyContent: "space-between" }}
      />
      <Text>{t("detectionZone.guide.description")}</Text>
      <DiscardDialog isOpen={isOpen} onClose={close} onDiscard={onClose} />
    </Box>
  );
}
